/**
 * Constants for Groups feature
 * Centralized configuration values
 */

export const GROUPS_CONSTANTS = {
  /** Default page size for fetching groups */
  DEFAULT_PAGE_SIZE: 1000,

  /** Maximum limit for fetching all groups */
  MAX_FETCH_LIMIT: 9999,

  /** Stale time for groups list (5 minutes) */
  STALE_TIME_MS: 5 * 60 * 1000,

  /** Cache garbage collection time (2 minutes) */
  GC_TIME_MS: 2 * 60 * 1000,

  /** Stale time for single group detail (1 minute) */
  DETAIL_STALE_TIME_MS: 60 * 1000,

  /** Cache garbage collection time for group detail (5 minutes) */
  DETAIL_GC_TIME_MS: 5 * 60 * 1000,
} as const;

/**
 * Sort field options for groups table
 */
export const GROUP_SORT_FIELDS = {
  name: "Nom",
  description: "Description",
  members_count: "Membres",
  created_at: "Créé le",
} as const;

/**
 * Toast messages for group operations
 */
export const GROUPS_MESSAGES = {
  CREATE_SUCCESS: "Groupe créé avec succès",
  CREATE_ERROR: "Erreur lors de la création du groupe",
  UPDATE_SUCCESS: "Groupe modifié avec succès",
  UPDATE_ERROR: "Erreur lors de la modification du groupe",
  DELETE_SUCCESS: "Groupe supprimé avec succès",
  DELETE_ERROR: "Erreur lors de la suppression du groupe",
  ADD_MEMBERS_SUCCESS: "Membres ajoutés avec succès",
  ADD_MEMBERS_ERROR: "Erreur lors de l'ajout des membres",
  REMOVE_MEMBERS_SUCCESS: "Membres supprimés avec succès",
  REMOVE_MEMBERS_ERROR: "Erreur lors de la suppression des membres",
  UPDATE_MEMBER_GROUPS_SUCCESS: "Groupes mis à jour avec succès",
  UPDATE_MEMBER_GROUPS_ERROR: "Erreur lors de la mise à jour des groupes",
  // Names the outcome the representative cares about, in the same words as the
  // badge it clears ("À vérifier") and the control that triggered it.
  ACKNOWLEDGE_SUCCESS: "Le groupe est de nouveau actif",
  ACKNOWLEDGE_ERROR: "La vérification du groupe n'a pas pu être enregistrée",
} as const;
